<template>
  <Card class="shopCard" @click="toDetail(data)" :thumb="data?.img">
    <template #title>
      <h2 class="ellipsisRowTwo">{{ data?.loyaltyName || '商品名称' }}</h2>
      <p class="remark" v-if="data?.ctag">
        <van-icon name="clock-o" /><span>{{ data?.ctag || '' }}</span>
      </p>
    </template>
    <template #price>
      <!-- <div class="price">零售价* ¥{{ data.uniformPrice || 0 }}{{ data.priceTypeFlag === 2 ? '起' : '' }}</div> -->
      <div class="price">{{ getPrice(data) }}</div>
    </template>
  </Card>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import { addEightHour } from '@/util'
import Card from '@/components/shop/Card'

export default {
  props: ['data', 'gsCode', 'customerCarId'],
  emits: ['link'],
  components: {
    Card
  },
  setup(props, { emit }) {
    let { data, gsCode, customerCarId } = toRefs(props)
    const state = reactive({
      data: data.value,
      gsCode,
      customerCarId
    })
    let toDetail = data => {
      emit('link', data)
    }
    const getPrice = data => {
      if (!data) {
        return ''
      }
      let str = ''
      let word = ''
      let num = 0
      let qi = ''
      let gsCode = state.gsCode
      let carId = state.customerCarId
      // suggestPrice	厂商建议零售价	 data.dealerPrice	经销商价格

      if (carId) {
          word = '建议零售价'
          num = data?.price
          qi = '起'
        str = `${word}* ¥${num} ${qi}`
      } else {
        str = ''
      }
      return str
      // 零售价* ¥{{ data.uniformPrice || 0 }}{{ data.priceTypeFlag === 2 ? '起' : '' }}
    }
    return {
      ...toRefs(state),
      toDetail,
      getPrice,
      addEightHour
    }
  }
}
</script>
<style lang="scss" scoped>
.shopCard {
  overflow: hidden;
  .van-card__content {
    font-size: 12px !important;
    div {
      margin-top: 4px;
    }
  }
  h2 {
    font-size: 14px !important;
    color: #333333;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .remark {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // align-items: flex-start;
    color: darkgoldenrod;
    font-weight: 100;
    .van-icon {
      margin-right: 5px;
    }
  }
  .price {
    font-size: 14px !important;
    font-weight: 600;
    color: #3088c5;
  }
}
</style>
